var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0.333252C5.5598 0.333252 0.33313 5.55992 0.33313 11.9999C0.33313 18.4399 5.5598 23.6666 11.9998 23.6666C18.4398 23.6666 23.6665 18.4399 23.6665 11.9999C23.6665 5.55992 18.4398 0.333252 11.9998 0.333252ZM11.9998 21.3333C6.8548 21.3333 2.66646 17.1449 2.66646 11.9999C2.66646 6.85492 6.8548 2.66659 11.9998 2.66659C17.1448 2.66659 21.3331 6.85492 21.3331 11.9999C21.3331 17.1449 17.1448 21.3333 11.9998 21.3333ZM17.3548 6.84325L9.66646 14.5316L6.6448 11.5216L4.9998 13.1666L9.66646 17.8333L18.9998 8.49992L17.3548 6.84325Z",
    fill: "#2C62BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertConfirm);
export default __webpack_public_path__ + "static/media/alertConfirm.b0f0d5f2.svg";
export { ForwardRef as ReactComponent };